<template>
    <div id="accommodation-consideration-form">
        <v-card>
            <v-card-title>
                <v-icon left :color="kingsGold">mdi-hand-heart</v-icon>Accommodation Consideration(s) (Optional)
            </v-card-title>
            <v-card-subtitle>
                To determine how we can best meet your special accommodation needs, it is helpful to
                understand your particular needs. Please provide additional information in the areas below
                if you have special accommodation needs.
            </v-card-subtitle>
            <v-card-text>
                <v-form ref="accommodationConsiderationForm" v-model="valid" lazy-validation>
                    <v-container class="px-0" fluid>
                        <!-- Super Single / Single Room Request Section -->   
                        <v-card-subtitle class="px-0" v-if="showSingleRoomRequest() == true">
                            <strong>Super Single Room / Single Room</strong>   
                            <br />Students will be placed into double rooms. If you wish Single Room accommodation, please select one of the following:             
                        </v-card-subtitle>
                        <v-card elevation="0" outlined v-if="showSingleRoomRequest() == true">
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12">
                                        <strong>Super Single Room</strong> - Individual space, with double bed with storage underneath, bedside table, wardrobe closet, desk and desk chair, love seat and ottoman, mini fridge and microwave combination. Shared bathroom with 3 other residents.  
                                        <br /><br />
                                        Additional room fee applies.
                                        <br /><br />
                                        Limited availability.
                                    </v-col>
                                    <v-col cols="12">
                                        <v-checkbox v-model="applicant.requestSuperSingle" hide-details true-value="yes" false-value="no" label="I am requesting a Super Single"></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card><br />
                        <v-card elevation="0" outlined v-if="showSingleRoomRequest() == true">
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12">
                                        <strong>Single Room</strong> - Double room with no roommate, two twin beds, two desks and desk chairs, two wardrobe closets. Shared bathroom with up to 6 residents.
                                        <br /><br />
                                        Additional room fee applies.
                                        <br /><br />
                                        Limited availability.
                                    </v-col>
                                    <v-col cols="12">
                                        <v-alert :color="infoColor" icon="mdi-information" outlined>
                                            Please provide medical documentation if you are applying for a single room. Submit to residence@kings.uwo.ca
                                        </v-alert> 
                                    </v-col>
                                    <v-col cols="12">
                                        <v-checkbox v-model="applicant.requestSingleRoom" hide-details true-value="yes" false-value="no" label="I am requesting a Single Room"></v-checkbox>
                                    </v-col>              
                                </v-row>
                            </v-card-text>
                        </v-card>
                        <!-- <v-alert :color="infoColor" icon="mdi-information" outlined>                                                                    
                            <b>Single Room Request</b>
                            <br>
                            In order to evaluate how we can best meet your special accommodation needs, we require additional information.  Please be advised that you may be asked to provide medical documentation to support your request, if your request is based on medical or mental health concerns.<br>
                            <b>Please note: there is an additional $1800 fee for single room accommodation</b>.<br>
                            While we welcome single room requests after the guarantee deadline, space limitations may limit single room assignments after that time.                        
                        <v-row>                                                                            
                            <v-col cols="12">
                                <v-checkbox v-model="applicant.singleRoomRequestReason" true-value="Medical concerns" false-value="" @change="setSingleRoomRequestOption" dense hide-details
                                    label="Medical concerns (ie: mobility, specific washroom facility needs, mental health, serious allergies, etc)"
                                    value="Medical concerns">
                                </v-checkbox> 
                                <v-checkbox v-model="applicant.singleRoomRequestReason" true-value="COVID concern" false-value="" @change="setSingleRoomRequestOption" dense hide-details
                                    label="COVID concern"
                                    value="COVID concern">
                                </v-checkbox> 
                                <v-checkbox v-model="applicant.singleRoomRequestReason" true-value="Other" false-value="" @change="setSingleRoomRequestOption" dense hide-details
                                    label="Other"
                                    value="Other">
                                </v-checkbox> 
                            </v-col> 
                            <v-card-subtitle class="px-0">
                                Please provide additional information relevant to your request, to help us understand your residence placement needs.  Consider not only single room, but also building placement factors that may assist you.  For example: 
                                <ul>
                                    <li>if noise levels are a concern, an area with less traffic (end of the hall vs. entrance of the residence floor), or an upper floor might be best</li>
                                    <li>if mobility is a concern, an area with few or no steps, or a room close to a washroom or elevator might be best</li>
                                </ul>
                            </v-card-subtitle>
                            <v-col cols="12">                                
                                <v-text-field auto-grow
                                    v-model="applicant.singleRoomRequestAdditionalInformation"                                    
                                    label="Please provide more information relevant to your request."                                    
                                    hint=""
                                    :disabled="singleRoomRequestAdditionalInfoDisabled == true"  
                                    :rules="singleRoomRequestOption != null ? [ singleRoomRequestAdditionalInfoRules ] : []"                                    
                                 outlined></v-text-field>
                            </v-col>                                            
                        </v-row> 
                        </v-alert>    -->
                        <!-- End Single Room Request Section -->     
                        <br /><v-divider></v-divider><br />               
                        <v-row>
                            <v-col cols="12">
                                <v-textarea v-model="applicant.specialAccommodationConsideration" auto-grow
                                    hint="For instance, is a main floor room for accessibility reasons, a room close to a washroom for medical reasons, a quieter area for sleep issues, or a single room for a particular reason. Please provide any information you believe to be relevant to your request."
                                    label="What type of accommodation consideration are you requesting and what needs motivate this request? (Optional)"
                                    persistent-hint :rules="specialAccommodationConsiderationRules" outlined>
                                </v-textarea>
                            </v-col>
                            <v-col cols="12">
                                <v-select v-model="applicant.specialAccommodationBasis"
                                    :items="specialAccommodationBasisItems"
                                    label="Is your request based on a significant impairment, medical condition, physical or personal challenge? (Optional)"
                                    :rules="specialAccommodationBasisRules">
                                </v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea v-model="applicant.specialAccommodationDescription" auto-grow
                                    label="Please describe the current impact and/or limitations imposed by your condition or challenge (Optional)"
                                    persistent-hint :rules="specialAccommodationDescriptionRules" outlined>
                                </v-textarea>
                            </v-col>
                        </v-row>     
                        <v-card-subtitle class="px-0">
                            <v-icon :color="kingsGold" left>mdi-signature</v-icon><b>Special Accommodations Terms</b>
                            <br>
                            I understand the Residence Office may, in confidence, share this information to consult with
                            Accessibility Services and /or Student Health Services to fully assess this
                            request. I give the Residence Office permission to do this. I give the Residence Office
                            permission to confirm with Accessibility Services that I have contacted
                            that office to arrange support services for the academic year.                            
                        </v-card-subtitle>
                        <v-row>
                            <v-col cols="12">
                                <v-checkbox v-model="applicant.specialAccommodationAgreeToTerms" false-value="0"
                                    label="I have read and agree to the Special Accommodations Terms" true-value="1">
                                </v-checkbox>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer>
                </v-spacer>
                <v-btn class="white--text" :color="successColor" @click="nextStep(5)">
                    Next
                </v-btn>
                <v-btn class="white--text" :color="kingsGrey" @click="prevStep(3)">
                    Previous
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'accommodation-consideration-form',
    props: {
        applicant: {
            required: true
        }
    },
    data() {
        return {
            specialAccommodationBasisItems: [{
                    text: 'Yes',
                    value: 'Yes'
                },
                {
                    text: 'No',
                    value: 'No'
                }
            ],
            singleRoomRequestOption : null,
            singleRoomRequestAdditionalInfoRules : (v) => !!v || 'Please provide additional information',
            alert: false,
            valid: true
        }
    },
    methods: {
        nextStep(val) {
            if (this.$refs.accommodationConsiderationForm.validate()) {
                // this.alert = false;
                this.$emit('setStep', val);
                this.$nextTick(() => {
                    this.$emit('scrollToTop');
                })
            }
            else {
                // this.alert = true;
                // this.$emit('scrollToTop');
            }
        },
        prevStep(val) {
            this.$emit('setStep', val);
            this.$nextTick(() => {
                this.$emit('scrollToTop');
            })
        },
        setSingleRoomRequestOption(val) {            
            this.singleRoomRequestOption = val;               
        },
        showSingleRoomRequest(){

            let buildingOption1Check = /Epworth Place/i.test(this.applicant.buildingOption01) || /King's Commons/i.test(this.applicant.buildingOption01);
            let buildingOption2Check = /Epworth Place/i.test(this.applicant.buildingOption02) || /King's Commons/i.test(this.applicant.buildingOption02);
            let upperyear = ["2", "3", "4"]
            let yearofStudyCheck = upperyear.includes(this.applicant.yearOfStudy)

            if(yearofStudyCheck && (buildingOption1Check || buildingOption2Check)){
                return false
            }

            return true

        }              
    },
    computed: {
        infoColor() {
            return '#5578eb';
        },
        kingsGold() {
            return '#d7ae28';
        },
        kingsGrey() {
            return '#6d6e71';
        },
        successColor() {
            return '#1bc5bd';
        },
        singleRoomRequestAdditionalInfoDisabled() {            
            if (this.singleRoomRequestOption != null) {
                return false
            }
            return true
        }

    }
}
</script>

<style scoped>
.v-input--checkbox,
.v-input--radio-group {
    margin-top: 0;
}
</style>